import {Route, Routes} from "react-router-dom";
import Homepage from "../pages/homepage/homepage";
import Contact from "../pages/contact/contact";
import Galerij from "../pages/galerij/galerij";
import SomethingWentWrong from "../pages/something-went-wrong/something-went-wrong";

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Homepage/>}/>
            <Route path={"/galerij"} element={<Galerij />}/>
            <Route path={"/contact"} element={<Contact />}/>
            <Route path={"*"} element={<SomethingWentWrong />} />
        </Routes>
    );
}

export default AppRouter;